import { render, staticRenderFns } from "./releaseItem.vue?vue&type=template&id=cc93f37c&scoped=true&"
import script from "./releaseItem.vue?vue&type=script&lang=js&"
export * from "./releaseItem.vue?vue&type=script&lang=js&"
import style0 from "./releaseItem.vue?vue&type=style&index=0&id=cc93f37c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc93f37c",
  null
  
)

export default component.exports